module.exports = __webpack_public_path__ + "static/media/Manual B612.c2d00b10.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual B612.pdf
// module id = 907
// module chunks = 0